
document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('.zoom-image-ani-img');
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.3
  };
  const callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is_active');
        observer.unobserve(entry.target);
      }
    });
  };
  const observer = new IntersectionObserver(callback, options);
  images.forEach(image => {
    observer.observe(image);
  });
});
